import React, { useState } from 'react';
import { Box, Typography, Button } from '@mui/material';
import { useHistory } from 'react-router-dom';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';

const programOptions = [
    'Aligned Program 1',
    'Aligned Program 2',
    'Aligned Program 3',
    'Aligned Program 4',
    'Aligned Program 5',
];

const AssessmentSelection = () => {
    const history = useHistory();
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const [selectedProgram, setSelectedProgram] = useState(null);
    const [dropdownAnchorEl, setDropdownAnchorEl] = useState(null);

    const handleDropdownToggle = (event) => {
        setIsDropdownOpen(!isDropdownOpen);
        setDropdownAnchorEl(event.currentTarget);
    };

    const handleProgramSelect = (program) => {
        setSelectedProgram(program);
        setIsDropdownOpen(false);
    };

    const handleNextClick = () => {
        if (selectedProgram) {
            // Proceed with the selected program
            console.log(`Selected program: ${selectedProgram}`);
        } else {
            alert("Please select a program before proceeding.");
        }
    };

    return (
        <Box
            sx={{
                height: '88vh',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                px: 2,
                textAlign: 'center',
            }}
        >
            <Typography sx={{ fontSize: '1.2rem', color: '#474747', mb: 4 }}>
                Let’s create an assessment for your program.
                Select a program from your list below or start from scratch.
            </Typography>

            <Box
                sx={{ position: 'relative', width: 400 }}> {/* Increased width */}
                <Box
                    sx={{
                        width: '100%',
                        padding: '16px',
                        borderRadius: '10px',
                        backgroundColor: '#fff',
                        color: '#EE6628',
                        border: '2px solid #EE6628',
                        boxShadow: '0 4px 10px rgba(0,0,0,0.1)',
                        cursor: 'pointer',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                    }}
                    onClick={handleDropdownToggle}
                >
                    <Typography variant="subtitle1" sx={{ fontWeight: 600, fontSize: '1.1rem' }}> {/* Increased font size */}
                        {selectedProgram || 'Select a Program'}
                    </Typography>
                    <ArrowDropDownIcon sx={{ color: '#EE6628', fontSize: '1.5rem' }} /> {/* Increased icon size */}
                </Box>

                {isDropdownOpen && (
                    <Box
                        sx={{
                            position: 'absolute',
                            top: '100%',
                            left: 0,
                            right: 0,
                            mt: 1,
                            backgroundColor: '#fff',
                            border: '2px solid #EE6628',
                            borderRadius: '8px',
                            zIndex: 10,
                            boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                            maxHeight: 300,
                            overflowY: 'auto',
                        }}
                    >
                        {programOptions.map((program, index) => (
                            <Box
                                key={index}
                                onClick={() => handleProgramSelect(program)}
                                sx={{
                                    padding: '14px 20px',
                                    cursor: 'pointer',
                                    color: '#EE6628',
                                    fontSize: '1.1rem',
                                    '&:hover': {
                                        backgroundColor: '#EE6628',
                                        color: '#fff',
                                    },
                                }}
                            >
                                {program}
                            </Box>
                        ))}
                    </Box>
                )}
            </Box>

            <Button
                sx={{
                    mt: 4,
                    px: 5,
                    backgroundColor: '#EE6628',
                    color: '#fff',
                    fontSize: '1rem',
                    '&:hover': { backgroundColor: '#EE6628' },
                }}
                onClick={handleNextClick}
            >
                Next
            </Button>
        </Box>
    );
};

export default AssessmentSelection;
